import { createContext } from "react";

export type ThemeMode = "light" | "dark";

interface ThemeContextType {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

const FluxThemeContext = createContext<ThemeContextType | null>(null);
export default FluxThemeContext;
